import { BaseRepository } from "@/repositories/base-repository"
import type { IKnownBusinessEntitySaleItem } from "@/interfaces/api/known-business-entity-sale-item.interface.ts"

export class KnownBusinessEntitySaleItemRepository extends BaseRepository<IKnownBusinessEntitySaleItem> {
  protected resourcePath = "administration/known-business-entities-sale-items"
}
